import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Cookies } from 'react-cookie-consent';

const LanguageContext = createContext(null);

// const countryLanguageMap = {
//   US: "en",
//   GB: "en",
//   IN: "hi",
//   FR: "fr",
//   DE: "de",
//   ES: "es",

//   // Japan
//   JP: "ja",
//   JA: "ja",

//   // South Korea
//   KR: "ko",
//   KO: "ko",
// };

/**
* In-memory translation cache
* Prevents repeated downloads

*/

const translationCache = new Map();

const SUPPORTED_LANGUAGES = [
  "en",
  "ja",
  "ko",
];

export const useLanguage = () => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }

  return context;
};

const getInitialLocale = () => {
  try {
    // const savedLanguage = localStorage.getItem("language");
    const savedLanguage = Cookies.get('locale')
    // const savedCountry = localStorage.getItem("country");
    console.log('savedLanguage**************1', savedLanguage);
    if (savedLanguage) {
      return {
        language: savedLanguage,
        // country: savedCountry,
      };
    }

    // const browserLocale = navigator.language || "en-US";

    // const [, detectedCountry = "US"] = browserLocale.split("-");

    // const country = detectedCountry.toUpperCase();
    console.log('savedLanguage**************', savedLanguage);
    return {
      // country,
      language: "en",
    };
  } catch {
    console.log('savedLanguage**************3', 'savedLanguage');
    return {
      language: "en",
      // country: "US",
    };
  }
};

export const LanguageProvider = ({ children, bucketUrl = Cookies.get('bucketUrl'), useLocalTranslations = true }) => {
  console.log(bucketUrl, 'bucketUrl*********************', Cookies.get('bucketUrl'));
  
  const [locale, setLocale] = useState(getInitialLocale);
  const [messages, setMessages] = useState({});
  const [loading, setLoading] = useState(true);
  const { language } = locale;

  const getTranslationUrl = useCallback(
    (lang) => {
      const normalizedLang = lang?.toLowerCase() || "en";

      return useLocalTranslations
        ? `/static/assets/Languages/${normalizedLang}.json`
        : `${bucketUrl}Language/${normalizedLang}.json`;
    },
    [bucketUrl, useLocalTranslations]
  );

//   useEffect(() => {
//   SUPPORTED_LANGUAGES.forEach(async (lang) => {
//     if (!translationCache.has(lang)) {
//       try {
//         const response = await fetch(
//           getTranslationUrl(lang),
//           {
//             cache: "force-cache",
//           }
//         );

//         if (!response.ok) return;

//         const data = await response.json();

//         translationCache.set(lang, data);

//         console.log(
//           `Preloaded language: ${lang}`
//         );
//       } catch (error) {
//         console.warn(
//           `Failed to preload ${lang}`,
//           error
//         );
//       }
//     }
//   });
// }, [getTranslationUrl]);

  /**
   * Fetch translations from Cloudflare CDN
  */

  // const fetchTranslations = useCallback(
  //   async (lang) => {
  //     const normalizedLang = lang?.toLowerCase() || "en";
  //     console.log('normalizedLang**************', normalizedLang, lang);

  //     /**
  //      * Return cached translations if already loaded
  //     */

  //     if (translationCache[normalizedLang]) {
  //       setMessages(translationCache[normalizedLang]);
  //       return;
  //     }

  //     try {
  //       setLoading(true);

  //       // const response = await fetch(
  //       //   `${bucketUrl}Language/${normalizedLang}.json`,
  //       //   {
  //       //     cache: "force-cache",
  //       //   },
  //       // );

  //       const response = await fetch(
  //         getTranslationUrl(normalizedLang),
  //         {
  //           cache: "force-cache",
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error(`Failed to load ${normalizedLang}.json`);
  //       }

  //       const data = await response.json();
  //       translationCache[normalizedLang] = data;
  //       setMessages(data);
  //       console.log(`Loaded translations: ${normalizedLang}`);
  //     } catch (error) {
  //       console.error(
  //         `Failed to load ${normalizedLang}.json. Falling back to English.`,
  //         error,
  //       );

  //       try {
  //         /**
  //          * Try English fallback from CDN
  //         */

  //         if (translationCache.en) {
  //           setMessages(translationCache.en);
  //           return;
  //         }

  //         const fallbackResponse = await fetch(getTranslationUrl("en"));
  //         // const fallbackResponse = await fetch(`${bucketUrl}Language/en.json`);
  //         const fallbackData = await fallbackResponse.json();
  //         translationCache.en = fallbackData;
  //         setMessages(fallbackData);
  //       } catch (fallbackError) {
  //         console.error(
  //           "Failed to load fallback translation",
  //           fallbackError,
  //         );
  //         setMessages({});
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [],
  // );

//   const fetchTranslations = useCallback(
//   async (lang) => {
//     const normalizedLang = lang?.toLowerCase() || "en";

//     /**
//      * Memory cache hit
//      */
//     if (translationCache.has(normalizedLang)) {
//       console.log(
//         `Loaded ${normalizedLang} from memory cache`
//       );

//       setMessages(
//         translationCache.get(normalizedLang)
//       );

//       return;
//     }

//     try {
//       setLoading(true);

//       const response = await fetch(
//         getTranslationUrl(normalizedLang),
//         {
//           cache: "force-cache",
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           `Failed to load ${normalizedLang}.json`
//         );
//       }

//       const data = await response.json();

//       /**
//        * Store in memory cache
//        */
//       translationCache.set(
//         normalizedLang,
//         data
//       );

//       setMessages(data);

//       console.log(
//         `Loaded ${normalizedLang} from network/browser cache`
//       );

//       /**
//        * Preload remaining languages
//        */
//       SUPPORTED_LANGUAGES
//         .filter(
//           (language) =>
//             language !== normalizedLang &&
//             !translationCache.has(language)
//         )
//         .forEach(async (language) => {
//           try {
//             const preloadResponse = await fetch(
//               getTranslationUrl(language),
//               {
//                 cache: "force-cache",
//               }
//             );

//             if (!preloadResponse.ok) return;

//             const preloadData =
//               await preloadResponse.json();

//             translationCache.set(
//               language,
//               preloadData
//             );

//             console.log(
//               `Preloaded: ${language}`
//             );
//           } catch {
//             // Ignore preload failures
//           }
//         });
//     } catch (error) {
//       console.error(
//         `Failed to load ${normalizedLang}.json`,
//         error
//       );

//       try {
//         /**
//          * English fallback
//          */
//         if (translationCache.has("en")) {
//           setMessages(
//             translationCache.get("en")
//           );
//           return;
//         }

//         const fallbackResponse = await fetch(
//           getTranslationUrl("en"),
//           {
//             cache: "force-cache",
//           }
//         );

//         const fallbackData =
//           await fallbackResponse.json();

//         translationCache.set(
//           "en",
//           fallbackData
//         );

//         setMessages(fallbackData);
//       } catch (fallbackError) {
//         console.error(
//           "Fallback failed",
//           fallbackError
//         );

//         setMessages({});
//       }
//     } finally {
//       setLoading(false);
//     }
//   },
//   [getTranslationUrl]
// );

const fetchTranslations = useCallback(
  async (lang) => {
    const normalizedLang = lang?.toLowerCase() || "en";

    if (translationCache.has(normalizedLang)) {
      console.log(
        `Loaded ${normalizedLang} from memory cache`
      );

      setMessages(
        translationCache.get(normalizedLang)
      );

      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        getTranslationUrl(normalizedLang),
        {
          cache: "force-cache",
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to load ${normalizedLang}.json`
        );
      }

      const data = await response.json();

      translationCache.set(
        normalizedLang,
        data
      );

      setMessages(data);

      console.log(
        `Loaded ${normalizedLang} from network`
      );
    } catch (error) {
      console.error(
        `Failed to load ${normalizedLang}.json`,
        error
      );
    } finally {
      setLoading(false);
    }
  },
  [getTranslationUrl]
);

  /**
   * Load translations whenever language changes
  */

  useEffect(() => {
    fetchTranslations(language);
  }, [language, fetchTranslations]);

  /**
   * Persist locale
  */

  useEffect(() => {
    localStorage.setItem("language",language);
    // localStorage.setItem("country",country);
    document.documentElement.lang = language;
  }, [language]);

  /**
   * Update language/country together
  */

  const updateLocale = useCallback(
    ({
      language: newLanguage,
      // country: newCountry,
    }) => {
      setLocale((prev) => ({
        ...prev,
        ...(newLanguage && {
          language: newLanguage.toLowerCase(),
        }),
        // ...(newCountry && {
        //   country: newCountry.toUpperCase(),
        // }),
      }));
    },
    [],
  );

  /**
   * Set language directly
  */

  const setLanguage = useCallback(
    (lang) => {
      updateLocale({
        language: lang,
      });
    },
    [updateLocale],
  );

  /**
   * Set country and automatically
   * map language
  */

  // const setCountry = useCallback(
  //   (countryCode) => {
  //     updateLocale({
  //       country: countryCode,

  //       language: countryLanguageMap[countryCode.toUpperCase()] || "en",
  //     });
  //   },
  //   [updateLocale],
  // );

  /**
   * Translation helper
  */

  const t = useCallback(
    (key, fallback = key) => messages?.[key] ?? fallback,
    [messages],
  );

  const value = useMemo(
    () => ({
      language,
      loading,
      setLanguage,
      updateLocale,
      t,
    }),
    [language, loading, setLanguage, updateLocale, t],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};